<template>
  <div style="padding-left: 24px; padding-right: 48px; position: relative;" class="py-3">
    <v-layout row>
      <v-flex xs2 sm1 class="align-self-center" :class="{'pl-3': $vuetify.breakpoint.smAndUp}">
        <v-icon medium>timelapse</v-icon>
      </v-flex>
      <v-flex xs5 sm2 class="align-self-center">
        {{$t('exemption.exemption')}}
      </v-flex>
      <v-flex xs5 sm2>
        <v-flex>
          {{exemption.startDate | date}}
        </v-flex>
        <v-flex>
          {{exemption.endDate | date}}
        </v-flex>
      </v-flex>
      <v-flex     sm5 class="align-self-center" v-if="$vuetify.breakpoint.smAndUp">
        {{exemption.exemptionReason.description}}
      </v-flex>
      <v-menu v-if="shouldShowMenu" lazy top style="position: absolute; right: 10px;">
        <v-btn flat icon slot="activator">
          <v-icon>more_horiz</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="editExemption">
            <v-icon class="pr-2">edit</v-icon>
            {{$t('edit')}}
          </v-list-tile>
          <v-list-tile v-if="shouldShowDelete" @click="deleteExemption(exemption.id)">
            <v-icon class="pr-2">delete</v-icon>
            {{$t('delete')}}
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-layout>
  </div>
</template>

<script>
  import DateFormat from '../../mixins/DateFormat'
  import EditExemption from '../../mixins/EditExemption'

  export default {
    name: 'student-exemption-row',
    props: ['exemption'],
    mixins: [DateFormat, EditExemption],
    data () {
      return {}
    },
    methods: {},
    computed: {},
    watch: {}
  }
</script>

<style scoped>
  .align-self-center {
    align-self: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/exemption/StudentExemptionRow.vue